// extracted by mini-css-extract-plugin
module.exports = {"item":"item-module--item--EsbDJ","text":"item-module--text--24LUn","underline":"item-module--underline--2kkUT","linkActive":"item-module--link-active--3U-su"};